import React, { useEffect, useState } from 'react';
import OtpInput from 'react-otp-input';
import Button from 'components/esaad-card/button';
import { saveEsaadCardData as sendOTP, verifyOTP } from 'services';
import useLoader from 'hooks/useLoader';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from 'constants';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';

const OTPVerification = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();
  const location = useLocation();
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otpRequired, setOtpRequired] = useState(false);
  const [uuid, setUuid] = useState('');

  useEffect(() => {
    setUuid(location?.state?.referenceId);
  }, [location.state]);

  const resendOTP = () => {
    const data = {
      emirateId: location?.state?.emiratesId,
      phoneNumber: location?.state?.mobileNumber,
      type: 'share'
    };
    showLoader();
    sendOTP(location?.state?.shareId, location?.state?.token, data)
      .then(res => {
        if (res?.data?.result) {
          setOtpSent(true);
          setUuid(res?.data?.data?.uuid);
        }
        hideLoader();
      })
      .catch(err => {
        hideLoader();
        Swal.fire('Error!', e?.response?.data?.meta?.message || e?.response?.data?.error?.message, 'error');
      });
  };

  const onClickVerify = () => {
    if (otp === '' || otp.length !== 4) {
      setOtpRequired(true);
      return false;
    } else {
      setOtpRequired(false);
    }
    showLoader();
    const data = {
      code: otp
    };
    verifyOTP(uuid, location?.state?.token, data)
      .then(res => {
        hideLoader();
        if (res?.data?.data) {
          navigate(ROUTES.ESAAD_CARD.SUCCESS);
        } else {
          navigate(ROUTES.ESAAD_CARD.FAILURE, {
            state: { message: 'Something went wrong. Please try again!' }
          });
        }
      })
      .catch(err => {
        hideLoader();
        navigate(ROUTES.ESAAD_CARD.FAILURE, {
          state: { message: err?.response?.data?.error?.message }
        });
      });
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center">
      <div className="mt-4" style={{ maxWidth: 370 }}>
        <p className="text-center text-light fw-bold mb-0" style={{ fontSize: 20 }}>
          {t('OTP_PAGE.OTP_VERIFICATION')}
        </p>
        <p className="mt-2 px-5 text-center text-light fw-normal mb-0" style={{ fontSize: 12 }}>
          {t('OTP_PAGE.OTP_RECEIVED_MESSAGE')} {`${location?.state?.mobileNumber}`.replace(/(\d{3})(.*)(\d{3})/, '$1****$3')}
        </p>
        <div className="mt-4 row">
          <div className="col-md-12 otp-window">
            <OtpInput
              value={otp}
              inputType="text"
              onChange={(val) => {
                if (val === '') {
                  setOtpRequired(true);
                } else {
                  setOtpRequired(false);
                }
                setOtp(val);
              }}
              numInputs={4}
              shouldAutoFocus
              renderInput={(props) => (
                <input
                  {...props}
                  style={{
                    width: '100%',
                    height: 52,
                    color: '#B4975A',
                    border: '2px solid #B4975A',
                    backgroundColor: '#8A1538',
                    borderRadius: 5,
                    fontSize: 20
                  }}
                  onChange={e => {
                    if (!isNaN(e.target.value)) {
                      // eslint-disable-next-line react/prop-types
                      props.onChange(e);
                    }
                  }}
                  className="text-center mx-2"
                />
              )}
            />
          </div>
        </div>
        <div className="row" style={{ marginTop: 22 }}>
          <div className="col-md-12">
            <Button
              title={t('COMMON.VERIFY')}
              backgroundColor="#B4975A"
              className="text-light fw-bold"
              onClick={onClickVerify}
            />
          </div>
        </div>
        {otpRequired && (
          <div
            className="mt-4 alert alert-danger alert-dismissible fade show p-2 fw-normal text-light" role="alert"
            style={{ backgroundColor: '#F45C5D', outline: 'none', border: 'none', fontSize: 14 }}>
            {t('MESSAGES.ENTER_VALID_OTP_MSG')}
            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" style={{ height: 0 }} onClick={() => setOtpRequired(false)}></button>
          </div>
        )}
        {otpSent && (
          <div
            className="mt-4 alert alert-success alert-dismissible fade show p-2 fw-normal" role="alert"
            style={{ outline: 'none', border: 'none', fontSize: 14 }}>
            {t('MESSAGES.OTP_SENT_MSG')}
            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" style={{ height: 0 }} onClick={() => setOtpSent(false)}></button>
          </div>
        )}
        <div className="mt-4">
          <p className="text-light fw-normal mb-0" style={{ fontSize: 12 }}>
            {t('OTP_PAGE.DIDNT_RECEIVED_OTP')}
            <span style={{ fontSize: 14 }} className="fw-bold" role="button" onClick={resendOTP}>
              {t('OTP_PAGE.REQUEST_AGAIN')}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OTPVerification;
